"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePhoneNumberWithReason = exports.validateCompanyNameWithReason = exports.validateCompanyName = exports.supportedPhoneNumberCharacters = exports.supportedCharacters = void 0;
exports.validateInput = validateInput;
exports.validateInputWithReason = validateInputWithReason;
exports.validateEmail = validateEmail;
const __1 = require("..");
exports.supportedCharacters = /^[a-z0-9!#$%&'*+/=?^_`{|}~.@-]*$/i;
exports.supportedPhoneNumberCharacters = /^[0-9() +-]*$/i;
function validateInput(input) {
    return validateInputWithReason(input) === 'success';
}
function validateInputWithReason(input) {
    if (!input) {
        return 'empty';
    }
    const trimmedInput = input.trim();
    if (trimmedInput.length === 0) {
        // Do not allow empty string
        return 'empty';
    }
    if (trimmedInput.length >= 40) {
        // SFDC has a max field length of 40 characters
        return 'longer_than_40';
    }
    if (trimmedInput.toLowerCase() === 'null') {
        return 'invalid';
    }
    const urlRegex = /(http[s]?:\/\/)?[^\s(["<,>]*\.[^\s[",><]*/im;
    if (urlRegex.test(trimmedInput)) {
        return 'invalid';
    }
    const invalidCharactersRegex = /[<>;{}\(\)\/~]/;
    if (invalidCharactersRegex.test(trimmedInput)) {
        return 'invalid_characters';
    }
    return 'success';
}
function validateEmail(value) {
    if (value == undefined || value.trim() === '') {
        return 'error_empty';
    }
    if (!exports.supportedCharacters.test(value.trim())) {
        //email may contain accents or special characters that are not supported by Salesforce
        return 'error_supported_characters';
    }
    if (!(0, __1.isEmailValid)(value)) {
        return 'error_invalid';
    }
    return 'success';
}
const validateCompanyName = (val) => {
    return (0, exports.validateCompanyNameWithReason)(val) === 'success';
};
exports.validateCompanyName = validateCompanyName;
const validateCompanyNameWithReason = (val) => {
    if (!val || !val.trim()) {
        return 'empty';
    }
    if (__1.invalidCharactersRegex.test(val)) {
        return 'invalid_characters';
    }
    if (val.trim().length >= 40) {
        return 'longer_than_40';
    }
    if (val.trim().toLowerCase() === 'null' || val.trim().toLowerCase() === 'undefined') {
        return 'invalid';
    }
    return 'success';
};
exports.validateCompanyNameWithReason = validateCompanyNameWithReason;
const validatePhoneNumberWithReason = (val) => {
    if (!val || !val.trim()) {
        return 'empty';
    }
    if (!exports.supportedPhoneNumberCharacters.test(val)) {
        return 'invalid_characters';
    }
    if (val.trim().length >= 40) {
        return 'longer_than_40';
    }
    return 'success';
};
exports.validatePhoneNumberWithReason = validatePhoneNumberWithReason;
//# sourceMappingURL=inputValidation.js.map